import React from 'react';
import {Styles} from './Styles';
//import Loader from 'react-loader-spinner'
//import './Loading.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
//import { fas } from '@fortawesome/free-solid-svg-icons';
import { faShoePrints } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Fade from '@material-ui/core/Fade';


interface Props {
    show:boolean,
    dir:"f"|"r"|"n",
    nextRoom:string,
}

const Bridge:React.FC<Props> = (props)=> {
    library.add(faShoePrints);
	const classes = Styles.bridge();
	return (
        <Fade in={props.show} timeout={{enter:250,exit:500}}>
		<div id="bridge" className={classes.paper}>
            {props.dir==="f" ? (
			<span className={classes.nextFloor}>
                {props.nextRoom}<br/>
                ↑<br/>
                <FontAwesomeIcon icon="shoe-prints" rotation={270}/>
            </span>
            ):(
			<span className={classes.nextRoom}>
                <FontAwesomeIcon icon="shoe-prints"/>
                →
                {props.nextRoom}
            </span>
            )}
		</div>
        </Fade>
    );
}

export default Bridge;
